import React from 'react';
import { Headphones, Building2, CreditCard, XCircle, Gift } from 'lucide-react';

const TrustStrip = () => {
  return (
    <div className="bg-white/5 rounded-xl p-4" data-testid="trust-strip">
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 md:gap-x-10">
        <div className="flex items-center gap-2">
          <XCircle className="h-4 w-4 text-green-400" />
          <span className="text-xs text-green-400 font-medium">Free Cancellation</span>
        </div>
        <div className="flex items-center gap-2">
          <Gift className="h-4 w-4 text-green-400" />
          <span className="text-xs text-green-400 font-medium">Free Meet & Greet</span>
        </div>
        <div className="flex items-center gap-2">
          <Headphones className="h-4 w-4 text-[#FF8C00]" />
          <span className="text-xs text-gray-400">24/7 Support</span>
        </div>
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4 text-[#FF8C00]" />
          <span className="text-xs text-gray-400">UK-based company</span>
        </div>
        <div className="flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-[#FF8C00]" />
          <span className="text-xs text-gray-400">PayPal available</span>
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
